import { Combobox } from "@newsela/angelou";
import { createStandardFilterCss } from "./StandardsSetsDropdownFilter.styles";

interface StandardDropdownFilterProps {
  filterLabel: string;
  filterItems: string[];
  currentItem: string;
  setItem: (item: string) => void;
}

export const StandardsSetsDropdownFilter = ({
  filterLabel,
  filterItems,
  currentItem,
  setItem,
}: StandardDropdownFilterProps) => (
  <Combobox
    label={filterLabel}
    items={["-", ...filterItems]}
    selectedItem={currentItem}
    onSelectedItemChange={(e) => {
      if (typeof e.selectedItem === "string") {
        setItem(e.selectedItem);
      }
    }}
    __cssFor={createStandardFilterCss}
  />
);
